import setting from './settings';

// Keys are campCode values, values are GA4 Measurement IDs. 
// Both are loaded from environment variables — adding a new camp = 1 line here.
export const CAMP_GA4_MAP = {
  [setting.api.ga4CampCode]: setting.api.ga4MeasurementId,
};
